import { FC } from 'react';
import { Box, Typography } from '@mui/material';
import useTranslations from '../global/translation/hooks/translation';
import { useThemeContext } from '../global/ThemeContext';
import { designTokens } from '../../theme/designTokens';

const Selectivity: FC = () => {
  const { currentLanguage, translations } = useTranslations();
  const { darkMode } = useThemeContext();
  const palette = darkMode ? designTokens.colors.dark : designTokens.colors.light;

  return (
    <Box
      sx={{
        bgcolor: darkMode ? palette.background.default : '#FFFFFF',
        py: { xs: 6, md: 9 },
        px: { xs: 3, md: 5 },
      }}
    >
      <Typography
        variant="h4"
        sx={{
          color: palette.text.primary,
          fontWeight: 400,
          fontSize: { xs: '1.85rem', md: '2.4rem' },
          letterSpacing: '-0.035em',
          textAlign: 'center',
          mb: { xs: 4.5, md: 7 },
        }}
      >
        {translations.label.forWhomTitle[currentLanguage]}
      </Typography>

      <Box
        sx={{
          display: 'grid',
          gridTemplateColumns: { xs: '1fr', md: 'repeat(2, minmax(0, 1fr))' },
          gap: { xs: 4, md: 6 },
          width: '100%',
          maxWidth: '1100px',
          mx: 'auto',
        }}
      >
        <Box
          sx={{
            borderLeft: `4px solid ${palette.primary}`,
            px: { xs: 2.5, md: 3.5 },
            py: { xs: 0.5, md: 1.5 },
          }}
        >
          <Typography
            variant="h5"
            sx={{
              color: palette.primary,
              fontWeight: 400,
              fontSize: { xs: '1.4rem', md: '1.65rem' },
              mb: { xs: 1.75, md: 2.5 },
              letterSpacing: '-0.03em',
            }}
          >
            ✓ {translations.label.forWhomTitle[currentLanguage]}
          </Typography>
          <Typography
            variant="body2"
            sx={{
              color: palette.text.secondary,
              lineHeight: 1.7,
              fontSize: { xs: '0.94rem', md: '1rem' },
            }}
          >
            {translations.label.forWhomText[currentLanguage]}
          </Typography>
        </Box>

        <Box
          sx={{
            borderLeft: `4px solid ${darkMode ? '#536582' : '#D3D8E1'}`,
            px: { xs: 2.5, md: 3.5 },
            py: { xs: 0.5, md: 1.5 },
          }}
        >
          <Typography
            variant="h5"
            sx={{
              color: darkMode ? '#AEBBD2' : '#8A8F98',
              fontWeight: 400,
              fontSize: { xs: '1.4rem', md: '1.65rem' },
              mb: { xs: 1.75, md: 2.5 },
              letterSpacing: '-0.03em',
            }}
          >
            ✕ {translations.label.notForWhomTitle[currentLanguage]}
          </Typography>
          <Typography
            variant="body2"
            sx={{
              color: darkMode ? '#8FA0BD' : '#8A8F98',
              lineHeight: 1.7,
              fontSize: { xs: '0.94rem', md: '1rem' },
              fontStyle: 'italic',
            }}
          >
            {translations.label.notForWhomText[currentLanguage]}
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};

export default Selectivity;
